class DepotStore {
  setInitialState({initialState}) {
    this.data = initialState.DepotStore
  }
}

export default DepotStore
